import isSampleStrVariantUtil from 'modules/variant/utils/is-sample-str'
import isMixedCollectionUrlLocationUtil from 'utils/location/is-mixed-collection-url'
import isHomeUrlUtil from 'utils/location/is-home-url'

/**
 * @param sku
 * @returns {*}
 */
export default function hasSampleBadgeProductVariantUtil ({ sku }) {
  return (
    isSampleStrVariantUtil(sku) &&
    (isMixedCollectionUrlLocationUtil() ||
    isHomeUrlUtil())
  )
}
